export interface WidgetTitleOverride {
  title: string;
}
export interface WidgetIconOverride {
  iconId: string;
}

export function hasWidgetIconId(object: any): object is WidgetIconOverride {
  return object?.iconId;
}

export function hasWidgetTitle(object: any): object is WidgetTitleOverride {
  return object?.title;
}
